import React, { useState, useEffect, use } from 'react';
import { websiteBanner } from '../../images/images';
import { TextField } from '@material-ui/core';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import { getConfigFromParamStore, getConfigFromStroage } from '../../utils/getUrlsFromAws';
import { getApiData } from '../../api/api';
import AxiosRequest from '../../utils/axios';
import { allowOnlyNumbers } from '../../utils/helperFunctions';
import { Button } from 'unified-ui-components-library';
import { CAPS_N, CAPS_Y, GENERATE_OTP_ATTEMPTS_ALLOWED } from '../../utils/constants';

const axios = new AxiosRequest().getClient()

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const MOBILE_PATTERN = /^[6-9]{1}[0-9]{9}$/;

const OTPVerification = ({ setOTPVerification, handlePoliciesData, redirectToLink }) => {
    const [countdown, setCountdown] = useState(59);
    const [startCountdown, setStartCountdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');
    const [email, setEmail] = useState('');
    const [isMobileNumberDisabled, setIsMobileNumberDisabled] = useState(false);
    const [isEmailDisabled, setIsEmailDisabled] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpSentMsg, setOtpSentMsg] = useState('');
    const [otp, setOtp] = useState('');
    const [sendOtpError, setSendOtpError] = useState('');
    const [verifyOtpError, setVerifyOtpError] = useState('');
    const [otpRefNumber, setOtpRefNumber] = useState('');
    const [alertData, setAlertData] = useState({
        open: false,
        type: "",
        msg: "",
        actions: []
    });
    const [otpSentCount, setOtpSentCount] = useState(0);
    const [otpValidationAttempts, setOtpValidationAttempts] = useState(0); 
    const [otpValidationMaxAttempts, setOtpValidationMaxAttempts] = useState(null); 

    useEffect(() => {
        setSendOtpError('')
    }, [mobileNumber, email])

    useEffect(() => {
        if (!startCountdown) {
            return;
        }
        const timer = setInterval(() => {
            console.log('timer', countdown);
            setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [startCountdown]);

    const getConfig = async () => {
        const urlData = getConfigFromStroage();
        if (urlData) {
            // verifyLink();
            return urlData;
        } else {
            return getConfigFromParamStore()
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobileNumber") {
            if (value == "") {
                setIsEmailDisabled(false);
            } else {
                setIsEmailDisabled(true);
                setEmail("")
            }
            if(value.length <= 10){
                setMobileNumber(value);
            }
        } else if (name === "email") {
            if (value == "") {
                setIsMobileNumberDisabled(false);
            } else {
                setIsMobileNumberDisabled(true);
                setMobileNumber('')
            }
            setEmail(value);
        }
    };

    const getOtp = async () => {
        setSendOtpError('');
        setLoading(true);
        setOtpValidationAttempts(0);
        setVerifyOtpError("")
        await getConfig();
        const { url, body } = getApiData("getOtp");
        body.request.payload.posvRefNumber = "1";
        if(mobileNumber) {
            body.request.payload.userIdentifierValue = mobileNumber;
            body.request.payload.userIdentifierType = "mobile";
        }
        if(email) {
            body.request.payload.userIdentifierValue = email;
            body.request.payload.userIdentifierType = "email";
        }
        body.request.payload.authToken = "";
        body.request.payload.onCallOTP = "No";
        body.request.payload.lang = "eng";
        body.request.payload.regenerateOTP = "N";
        body.request.payload.clubbeOtpDetails = null;
        body.request.payload.sendPosvLink = "Y";
        try {
            const response = await axios.post(url, body);
            console.log({ response });
            setOtpSentCount(otpSentCount + 1);
            if (response?.data?.response?.msgInfo?.msgCode === "200") {
                const maxAttempts = response?.data?.response?.payload?.maxPosvPortalAttempCount
                setOtpSentMsg(response?.data?.response?.payload?.levelMessage);
                setOtpSent(true);
                setCountdown(59);
                setStartCountdown(true);
                setOtpRefNumber(response.data.response.payload.posvRefNumber);
                setOtpValidationMaxAttempts(parseInt(maxAttempts));
                setOtp('');
            } else {
                setSendOtpError(response?.data?.response?.payload?.businessMsg);
            }
        } catch (error) {
            console.log({ error });
            setSendOtpError("Something went wrong. Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    const validateOtp = async () => {
        setVerifyOtpError('');
        const { url, body } = getApiData("validateOtp");
        body.request.payload.otp = otp;
        body.request.payload.mobileNumber = mobileNumber;
        body.request.payload.sendPosvLink = "Y";
        body.request.payload.posvRefNumber = otpRefNumber;
        body.request.payload.isNeoMobilenumber = null;
        if(mobileNumber) {
            body.request.payload.isNeoMobilenumber = CAPS_Y
        }
        if(email){
            body.request.payload.isNeoMobilenumber = CAPS_N
        }

        try {
            setLoading(true);
            setOtpValidationAttempts((prev) => (prev + 1))
            const response = await axios.post(url, body);
            if (response?.data?.response?.messageInfo?.msgCode === "200") {
                const policies = response.data.response.payload.detailedPolicies
                if(policies?.length === 1) {
                    redirectToLink(policies[0]?.posvRefNumber);
                } else {
                handlePoliciesData(policies);
                setOTPVerification(false);
                }
            } else {
                setVerifyOtpError(response?.data?.response?.payload?.businessMsg);
            }
        } catch (error) {
            console.log({ error });
            setVerifyOtpError("Something went wrong. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const validateSendOtpBtn = () => {
        if (!mobileNumber && !email) {
            return true;
        }
        if(mobileNumber && !MOBILE_PATTERN.test(mobileNumber)) {
            return true;
        }
        if(email && !EMAIL_PATTERN.test(email)) {
            return true;
        }
        return false;
    }

    return (
        <div className='policy_pack_cntnr link_view_otp_verification'>
            {loading && <DotsLoader msg={"Please wait..."} />}

            <div className='policy_pack_form'>
                <div className='policy_pack_heading'>
                    <h3>Complete your pending policy verification here</h3>
                    <p>View and take action over your pending verification links by logging in with your registered mobile number or email id</p>
                </div>
                <div className='policy_pack_heading link_view_otp_verification'>
                    <h3>{otpSent ? 'Enter OTP' : 'Login'}</h3>
                    {otpSent && <p>{otpSentMsg}</p>}
                </div>
                <div className='pp-from'>
                    {
                        !otpSent && <>
                            <TextField
                                id="mobileNum"
                                label="Mobile Number"
                                type="number"
                                name='mobileNumber'
                                className="new-ui-txt-field"
                                autoComplete="off"
                                variant="outlined"
                                fullWidth
                                value={mobileNumber}
                                onChange={handleInputChange}
                                error={sendOtpError?.length > 0 && !isMobileNumberDisabled}
                                onKeyDown={allowOnlyNumbers}
                                disabled={email.length}
                            />
                            {sendOtpError && !isMobileNumberDisabled && <p className='pp-otp-msg'>{sendOtpError}</p>}
                            {!isMobileNumberDisabled && mobileNumber.length > 0 && !MOBILE_PATTERN.test(mobileNumber) && <p className='pp-otp-msg'>Please enter valid mobile number</p>}
                            <div
                                className='or-div'
                            >
                                <p>or</p>
                            </div>
                            <TextField
                                id="email"
                                label="Email id"
                                type="email"
                                name='email'
                                className="new-ui-txt-field"
                                autoComplete="off"
                                variant="outlined"
                                fullWidth
                                value={email}
                                onChange={handleInputChange}
                                error={sendOtpError?.length > 0 && !isEmailDisabled}
                                disabled={mobileNumber.length}
                            />
                            {!isEmailDisabled && email.length > 0 && !EMAIL_PATTERN.test(email) && <p className='pp-otp-msg'>Please enter valid email id</p>}
                            {sendOtpError && !isEmailDisabled && <p className='pp-otp-msg'>{sendOtpError}</p>}
                            <div className='button_div_unified'>
                                <Button
                                    onClick={getOtp}
                                    // className='pp-submit-btn'
                                    disabled={validateSendOtpBtn()}
                                    buttonType='primary'
                                    size='default'
                                >
                                    Send OTP
                                </Button>
                            </div>
                        </>
                    }
                    {
                        otpSent && <>
                            {
                               otpSentCount === GENERATE_OTP_ATTEMPTS_ALLOWED ? <>
                                <p className='small-txt'>You have exceeded all your attempts to receive OTP, please contact the helpdesk No. 1800 121 8143/ 1800 102 8672</p>
                               </> : <p className='resend-otp'>Didn’t receive the OTP?{" "}
                                {
                                    countdown > 0 ? (
                                        <span className='resend_txt_link_view'>Resend in{" "}
                                            <span className='resend_timer_link_view'>00:{countdown < 10 ? `0${countdown}` : countdown}s</span>
                                        </span>
                                    ) : <span
                                        className='link_view_resend_otp_btn'
                                        onClick={getOtp}
                                    >
                                        Resend OTP
                                    </span>

                                }
                            </p>
                            }
                            <TextField
                                id="otp"
                                label="6 Digit OTP"
                                type="number"
                                className="new-ui-txt-field"
                                autoComplete="off"
                                variant="outlined"
                                fullWidth
                                value={otp}
                                onChange={(e) => (e.target.value.length <= 6) && setOtp(e.target.value)}
                                error={verifyOtpError?.length > 0}
                                onKeyDown={allowOnlyNumbers}
                            />
                            {
                                otpValidationAttempts === otpValidationMaxAttempts ? (
                                    <p className='pp-otp-msg'>{"You have exceeded all your attempts to verify OTP, Please resend OTP"}</p>
                                ) : (verifyOtpError ? <p className='pp-otp-msg'>{verifyOtpError}</p> : null)
                                
                            }
                            <div className='button_div_unified'>
                                <Button
                                    onClick={validateOtp}
                                    // className='pp-submit-btn'
                                    disabled={otp.length !== 6 || otpValidationAttempts === otpValidationMaxAttempts}
                                    buttonType='primary'
                                    size='default'
                                >
                                    Verify OTP
                                </Button>
                            </div>
                        </>
                    }
                </div>

            </div>
            <div className='policy_pack_banner'>
                <img src={websiteBanner} alt="Banner" />
            </div>
        </div>
    );
};

export default OTPVerification;